import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M9 13.714a4.714 4.714 0 1 0 0-9.428 4.714 4.714 0 0 0 0 9.428M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M11.768 7.126a.6.6 0 0 1 .106.842l-2.8 3.6a.6.6 0 0 1-.849.1l-2-1.6a.6.6 0 1 1 .75-.937l1.525 1.22 2.426-3.12a.6.6 0 0 1 .842-.105",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-success"}) } }